import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "tabContent"];
  connect() {
    this.current_tab = parseInt(this.element.dataset.defaultTab) || 0;

    this.tabTargets[this.current_tab].classList.add("active");
    this.tabContentTargets[this.current_tab].classList.add("active");
  }

  changeTab(e) {
    this.tabTargets.forEach((tab) => {
      tab.classList.remove("active");
    });

    this.tabContentTargets.forEach((content) => {
      content.classList.remove("active");
    });

    const index = this.tabTargets.indexOf(e.target);
    this.tabTargets[index].classList.add("active");
    this.tabContentTargets[index].classList.add("active");
  }
}
